var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('info-panel',{staticClass:"my-4 relative gateway-column-content"},[_c('template',{slot:"content"},[_c('div',{staticClass:"w-full h-full rounded-t-lg relative"},[_c('div',{staticClass:"bg-contain bg-no-repeat bg-center h-48 w-full",style:({
            backgroundImage:
              'url(' +
              require('../assets/images/logo/' +
                _vm.gatewayIntegration.platform +
                '-integration.png') +
              ')',
          })})])]),_c('template',{slot:"footer"},[_c('div',{staticClass:"flex w-full pl-4 justify-between items-center"},[_c('div',{staticClass:"flex flex-col items-center justify-center w-full"},[_c('div',{staticClass:"flex flex-col justify-left w-full"},[_c('p',{staticClass:"text-sm"},[_vm._v(" "+_vm._s(_vm.gatewayIntegration.name)+" ")])])]),_c('drop-menu',{attrs:{"menu-items":_vm.menuItems,"small":""}})],1)])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }